<template>
  <div class="menu-box">
    <div class="menu-item" :class="[`level${menuData.hLevel}`, { cur: isCur }]">
      <span v-if="menuData.children" class="ic-arr" :class="{ close: !isOpen }" @click="switchClick">
        <t-icon name="chevron-down" />
      </span>
      <span v-else class="ic-dot"></span>
      <a :href="`#${menuData.domId}`" :title="menuData.title" class="btn-link" @click="clickItem">{{
        menuData.title
      }}</a>
    </div>
    <div v-if="menuData.children" v-show="isOpen">
      <customMenu v-for="(subMenu, index) in menuData.children" :key="index" :menuData="subMenu" @clickAction="clickAction"></customMenu>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'customMenu',
  computed: {},
  props: {
    menuData: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapState('sideNav', ['curAnchor']),
    isCur() {
      return this.curAnchor === this.menuData.domId;
    },
  },
  data() {
    return {
      isOpen: true,
    };
  },
  methods: {
    ...mapMutations('sideNav', ['setCurAnchor']),
    switchClick() {
      this.isOpen = !this.isOpen;
    },
    clickItem() {
      this.setCurAnchor(this.menuData.domId);
      this.clickAction();
    },
    clickAction() {
      this.$emit('clickAction');
    },
  },
};
</script>
<style scoped>
.menu-box {
  max-width: 100%;
}
.menu-item {
  display: flex;
  align-items: center;
  position: relative;
}
.menu-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -14px;
  width: 2px;
  height: 100%;
  background-color: #e5e7e9;
}
.menu-item.cur::after {
  content: '';
  position: absolute;
  top: 10%;
  left: -14px;
  width: 2px;
  height: 80%;
  background-color: #0052d9;
}
.menu-box .btn-link {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #6f7682;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
  line-height: 28px;
  display: block;
  flex: 1;
}
.menu-box .cur .btn-link {
  color: #000;
  font-weight: 700;
}
.menu-box .btn-link:hover {
  font-weight: 700;
}
.menu-box .ic-dot {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-box .ic-arr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  transition: all 0.3s;
  line-height: 1;
  cursor: pointer;
  font-size: 16px;
}
.menu-box .ic-arr.close {
  transform: rotate(-90deg);
}
.menu-item.level2 {
  padding-left: 8px;
}
.menu-item.level3 {
  padding-left: 16px;
}
.menu-item.level4 {
  padding-left: 24px;
}
.menu-item.level5 {
  padding-left: 32px;
}
.menu-item.level6 {
  padding-left: 40px;
}
</style>
